import { useMemo } from "react";

import { RHFStringInput } from "@impero-com/common/components/form/rhfFields/rhfStringInput";
import { useTranslation } from "@impero-com/common/utils/i18n";
import { Control, useFormState, UseFormWatch } from "react-hook-form";

import {
    ControlProgramTagCategoryCreateFormSchema,
    refinedCreateTagNameSchema,
} from "../useControlProgramTagCategoryFormSchema";

export function CreateNewTagNameInput({
    control,
    handleAddTag,
    watch,
}: {
    control: Control<ControlProgramTagCategoryCreateFormSchema>;
    handleAddTag: () => Promise<void>;
    watch: UseFormWatch<ControlProgramTagCategoryCreateFormSchema>;
}) {
    const { t } = useTranslation();
    const { isDirty } = useFormState({
        control,
        name: "tags",
    });
    const tags = watch("tags");

    const existingTagNames = useMemo(() => {
        return tags.map((tag) => tag.name);
    }, [tags]);

    return (
        <RHFStringInput
            control={control}
            name={"newTagName"}
            schema={refinedCreateTagNameSchema(t, existingTagNames)}
            placeholder={t("TagManagementTable_Add_Placeholder")}
            onKeyDown={(e) => {
                if (e.code === "Enter") {
                    void handleAddTag();
                }
            }}
            autoFocus={isDirty} // Allow autofocus only if tags have been added
        />
    );
}
